import { useColorMode } from "@/ui/hooks";

export default function ColorModeToggle({ children }: { children: any }) {
  const { toggleColorMode } = useColorMode();
  // @ts-ignore
  window.toggleColorMode = toggleColorMode;
  return children;
}
